const messages = {
  es: {
    translations: {
      common: {
        yes: "Sí",
        no: "No",
        save: "Guardar",
        cancel: "Cancelar",
        confirm: "Confirmar",
        delete: "Eliminar",
        edit: "Editar",
        add: "Agregar",
        create: "Crear",
        update: "Actualizar",
        close: "Cerrar",
        back: "Atrás",
        next: "Siguiente",
        previous: "Anterior",
        search: "Buscar",
        loading: "Cargando...",
        noData: "Sin datos",
        error: "Error",
        success: "Éxito",
        warning: "Advertencia"
      },
      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado exitosamente! Por favor inicia sesión",
          disabled:
            "El registro de usuario está deshabilitado actualmente. Por favor intenta más tarde.",
          fail: "Error al crear usuario. Por favor verifica los datos proporcionados.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Organización",
          phone: "WhatsApp (Código de Área + Número)",
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Iniciar Sesión",
        welcomeBack: "Bienvenido",
        subtitle: "Ingrese sus credenciales para acceder",
        heroTitle: "Gestiona tus conversaciones en un solo lugar",
        heroDescription:
          "Centraliza tickets, mensajes y contactos con una experiencia de acceso limpia, segura y moderna.",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Acceder",
        },
        buttons: {
          submit: "Entrar",
          register: "¿No tienes una cuenta? Regístrate",
          forgotPassword: "¿Olvidaste tu contraseña?",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada exitosamente!",
        },
        toasts: {
          loadError: "No se pudo cargar la lista de empresas.",
          saveSuccess: "¡Operación realizada con éxito!",
          saveError: "No se pudo completar la operación. Verifica si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente.",
          deleteSuccess: "¡Operación realizada con éxito!",
          deleteError: "No se pudo completar la operación."
        }
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Tu suscripción vence en",
          days: "¡días!",
          day: "¡día!",
          expirationToday: "¡Tu suscripción vence hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: {
          show: "Mostrar Filtros",
          hide: "Ocultar Filtros",
        },
        filter: "FILTRO ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Agentes",
        },
        sections: {
          indicators: "Indicadores",
          satisfactionSurvey: "Encuesta de Satisfacción",
          attendances: "Atenciones",
          ratingIndex: "Índice de Calificación",
          attendants: "Agentes",
        },
        nps: {
          score: "Puntuación",
          promoters: "Promotores",
          neutrals: "Neutrales",
          detractors: "Detractores",
        },
        attendances: {
          total: "Total de Atenciones",
          waitingRating: "Atenciones Esperando Calificación",
          withoutRating: "Atenciones sin Calificación",
          withRating: "Atenciones Calificadas",
        },
        export: {
          attendantsReport: "Reporte de Agentes",
          attendantsReportFileName: "reporte-agentes.xlsx",
        },
        charts: {
          perDay: {
            title: "Atenciones hoy: ",
          },
        },
        cards: {
          inAttendance: "En Atención",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizado",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "Tiempo Promedio de Servicio",
          averageWaitingTime: "Tiempo Promedio de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Número de Atenciones",
          statusNow: "Estado Actual",
          totalCallsUser: "Total de Atenciones por Usuario",
          totalAttendances: "Total de Atenciones",
        },
        date: {
          initialDate: "Fecha de Inicio",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponible hasta",
        },
        assessments: {
          totalCalls: "Total de Atenciones",
          callsWaitRating: "Atenciones Esperando Calificación",
          callsWithoutRating: "Atenciones sin Calificación",
          ratedCalls: "Atenciones Calificadas",
          evaluationIndex: "Índice de Evaluación",
          score: "Puntuación",
          prosecutors: "Promotores",
          neutral: "Neutral",
          detractors: "Detractores",
        },
      },
      reports: {
        title: "Reportes de Investigación",
        operator: "Operador",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Reportes",
        calls: "Atenciones",
        search: "Encuestas",
        durationCalls: "Duración de Atenciones",
        grupoSessions: "Atenciones de Grupo",
        groupTicketsReports: {
          timezone: "America/Bogota",
          msgToast: "Generando reporte comprimido, por favor espera.",
          errorToast: "Error al generar reporte",
          back: "Atrás",
          groupServiceReport: "Reporte de Atención de Grupo",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha de Última Actualización",
          agent: "Agente",
          agentClosed: "Agente que cerró",
          waitingAssistance: "Esperando Servicio",
          process: "En Servicio",
        },
        researchReports: {
          response: "Respuesta",
          active: "(Activo)",
          inactive: "(Inactivo)",
          quantity: "Cantidad",
          percentage: "Porcentaje",
          title: "Reportes de Investigación",
          activeSearch: "Encuesta Activa",
          inactiveSearch: "Encuesta Inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando reporte comprimido, por favor espera.",
          title: "Reporte de Duración de Atención",
          startService: "Inicio de Atención",
          lastUpdated: "Última Actualización",
          lastAgent: "Último Agente",
          durationFinished: "Duración Después del Cierre",
        },
        ticketDuration: {
          title: "Reporte de Duración de Atención",
          contact: "Contacto",
          open: "Abierto",
          pending: "Pendiente",
          finished: "Finalizado",
          durationFinished: "Duración de Atenciones Finalizadas",
          durationAfterFinished: "Duración Después del Cierre",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando reporte comprimido, por favor espera.",
          title: "Reporte de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha de inicio",
          endDate: "Fecha de fin",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Cola",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha de Apertura",
            openTime: "Hora de Apertura",
            closeDate: "Fecha de Cierre",
            closeTime: "Hora de Cierre",
            supportTime: "Tiempo de Soporte",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Listado de Atenciones Completadas",
          exportTitle: "Listado de Atenciones de Grupo Completadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      audioRecorder: {
        recordButton: "Grabar Audio",
        recordingLabel: "Grabando...",
        recordedLabel: "Audio grabado - {{time}}",
        recordedHelp: "Haz clic en ✓ para confirmar o en 🗑️ para eliminar",
      },
      contactImportWpModal: {
        title: "Exportar Contactos a Excel",
        buttons: {
          downloadModel: "Descargar plantilla Excel para importar",
          closed: "Cerrar",
          import: "Selecciona archivo Excel para importar Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Por favor espera... ¡Tus conexiones se reiniciarán!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar Soporte",
        transferTickets: "Transferir Tickets",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          "Conecta tus canales de servicio para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: "Conexiones:",
        channel: "Canal",
        whatsappOfficial: "WhatsApp Oficial",
        connectNewAccount: "Conectar nueva cuenta",
        selectChannel: "Seleccione el canal",
        pageName: "Nombre de la página",
        instagramHandle: "Usuario de Instagram",
        badges: {
          linked: "Vinculada",
        },
        channelDescriptions: {
          whatsapp: "Código QR y gestión clásica de sesiones.",
          facebook: "Conecta las páginas de Facebook y recibe mensajes de Messenger.",
          instagram: "Conecta el perfil de empresa y centraliza los mensajes directos.",
        },
        steps: {
          stepOne: "Paso 1",
          stepTwo: "Paso 2",
          loginFacebook: "Accede a Facebook",
          selectPage: "Selecciona la página",
          selectInstagram: "Selecciona el perfil de Instagram",
        },
        facebook: {
          success: "¡Conexión de Facebook establecida exitosamente!",
        },
        transfer: {
          title: "Transferencia de Ticket",
          description: "Para transferir tickets, selecciona la",
          descriptionBold1: "conexión de origen",
          descriptionMiddle: "(desde donde se moverán los tickets) y la",
          descriptionBold2: "conexión de destino",
          descriptionEnd: "(donde se transferirán los tickets). Todos los chats activos de la conexión de origen se moverán a la conexión de destino.",
          origin: "Origen",
          destination: "Destino",
          transferButton: "TRANSFERIR",
          cancel: "CANCELAR",
          selectConnections: "Selecciona conexiones de origen y destino",
          differentConnections: "Las conexiones de origen y destino deben ser diferentes",
          successMessage: "¡Tickets transferidos exitosamente!",
          successMessageWithCount: "Transferencia exitosa: {{count}} tickets transferidos.",
          transferComplete: "¡Transferencia completada!",
          transferError: "Error al transferir tickets.",
          progressTitle: "Transfiriendo Tickets",
          progressDescription: "Progreso de Transferencia",
          progressMessage: "de",
          progressMessageEnd: "tickets transferidos",
          progressWait: "Por favor espera mientras se transfieren los tickets...",
          preDeleteTitle: "Transferencia de Ticket",
          preDeleteMessage: "Antes de eliminar esta conexión, ¿ya has transferido los tickets a otra conexión?",
          preDeleteNo: "NO",
          preDeleteYes: "SÍ",
        },
        syncTemplates: {
          tooltip: "Sincronizar plantillas",
        },
        copyWebhook: {
          tooltip: "Copiar webhook para Meta",
        },
        toasts: {
          deleted: "¡Conexión eliminada exitosamente!",
          closedimported:
            "Cerrando tickets importados, por favor espera unos momentos.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "Si confirmas, todos los tickets importados serán cerrados.",
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede deshacer.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "¿Estás seguro? Necesitarás escanear el Código QR nuevamente.",
        },
        buttons: {
          add: "Agregar Conexión",
          disconnect: "Desconectar",
          tryAgain: "Intentar de Nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "NUEVO CÓDIGO QR",
          closedImported: "Cerrar todos los tickets importados",
          preparing: "Preparando mensajes para importar",
          importing: "Importando Mensajes de WhatsApp",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando",
          connect: "Conectar",
          disconnectSocial: "Desvincular",
          loginWithFacebook: "Login with Facebook",
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del Mensaje",
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión en WhatsApp",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet e intenta de nuevo, o solicita un nuevo Código QR.",
          },
          qrcode: {
            title: "Esperando escaneo del Código QR",
            content:
              "Haz clic en el botón 'CÓDIGO QR' y escanea el Código QR con tu teléfono para iniciar la sesión.",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content:
              "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en 'Desconectar' para obtener un nuevo Código QR.",
          },
        },
        table: {
          channel: "Canal",
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
          number: "Número",
          color: "Color",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atención Existente",
        },
        form: {
          message: "Este contacto ya está siendo atendido:",
          user: "Agente",
          queue: "Cola",
          messageWait:
            "Este contacto ya está esperando servicio. ¡Verifica la pestaña Esperando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Registros",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: "- Cola asignada.",
          open: "inició el servicio.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la cola.",
          closed: "cerró el ticket.",
          reopen: "reabrió el ticket.",
          redirect: "- redirigió",
          clientClosed: "Cliente cerró el ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar Conexión",
          edit: "Editar Conexión",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          schedules: "Horarios de Negocio",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del dispositivo",
          importOldMessages: "Fecha de inicio de importación",
          importRecentMessages: "Fecha de fin de importación",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de importar",
          name: "Nombre",
          queueRedirection: "Redirección de Cola",
          queueRedirectionDesc:
            "Selecciona una cola para contactos sin cola asignada",
          default: "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la cola",
          importAlert:
            "ADVERTENCIA: Guardar terminará tu conexión. Necesitarás escanear el Código QR nuevamente para importar mensajes.",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Crear un nuevo ticket después de X minutos",
          maxUseBotQueues: "Enviar bot X veces",
          maxUseInactiveTime: "Enviar flujo de inactividad X veces",
          timeUseBotQueues: "Enviar bot en X minutos",
          timeToReturnQueue: "Tiempo para regresar a la cola en minutos",
          timeAwaitActiveFlow: "Tiempo para esperar flujo activo",
          expiresTicket: "Cerrar chats abiertos después de X minutos",
          expiresTicketNPS: "Cerrar chats esperando evaluación después de X minutos",
          maxUseBotQueuesNPS: "Máximo de veces que se envía evaluación",
          closeLastMessageOptions1: "De agente/cliente",
          closeLastMessageOptions2: "Solo de agente",
          outOfHoursMessage: "Mensaje fuera de horario",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de finalización",
          lgpdLinkPrivacy: "Enlace de política de privacidad",
          lgpdMessage: "Mensaje de bienvenida LGPD",
          lgpdDeletedMessages: "Ofuscar mensajes eliminados por contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de Evaluación - La escala debe ser de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Cola",
          inactiveMessage: "Mensaje de advertencia de inactividad",
          timeInactiveMessage: "Tiempo en minutos para enviar advertencia de inactividad",
          flowInactiveTime: "Tiempo en minutos para enviar flujo de inactividad",
          whenExpiresTicket: "Cerrar chats cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha de fin",
          collectiveVacationStart: "Fecha de inicio",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Cola para importación de mensajes",
          isOficial: "Oficial",
          phone_number_id: "ID del Número de Teléfono",
          waba_id: "ID de WABA",
          send_token: "Token de Envío",
          business_id: "ID de Negocio",
          phone_number: "Número de teléfono",
          triggerIntegrationOnClose: "Activar Integración al Cerrar Ticket",
          enableIntegration: "Integración Habilitada",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos",
        },
        success: "Conexión guardada exitosamente.",
        errorSendQueue:
          "Estableciste un tiempo de redirección pero no seleccionaste ninguna cola. Ambos campos son requeridos.",
        errorExpiresNPS: "Debe establecerse un tiempo de espera para la evaluación NPS.",
        errorRatingMessage: "Se debe proporcionar un mensaje de evaluación para NPS.",
      },
      qrCode: {
        message: "Escanea el Código QR para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
        toasts: {
          deleted: "¡Contacto eliminado exitosamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "Flujos de Conversación",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo",
        confirmationModal: {
          deleteTitle: "Eliminar",
          importTitlte: "Importar Contactos",
          exportContact: "Exportar Contactos",
          deleteMessage:
            "¿Estás seguro de que deseas eliminar este contacto? Se perderán todas las atenciones relacionadas.",
          blockContact: "¿Estás seguro de que deseas bloquear este contacto?",
          unblockContact: "¿Estás seguro de que deseas desbloquear este contacto?",
          importMessage: "¿Deseas importar todos los contactos del teléfono?",
          importChat: "Importar Chats",
          wantImport: "¿Deseas importar todos los chats del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          email: "Correo Electrónico",
          ownerPhone: "Teléfono asociado",
          actions: "Acciones",
          lastMessage: "Último Mensaje",
          wallet: "Cartera",
          status: "Estado",
          photo: "Foto",
          id: "ID",
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar/Exportar desde Excel",
          importexport: "IMPORTAR / EXPORTAR",
          deleteAllContacts: "Eliminar Todos los Contactos",
        },
        bulk: {
          selectAll: "Seleccionar todos los contactos",
          selected: "seleccionado",
          allSelected: "(TODO)",
          deleteSelected: "Eliminar Seleccionados",
          deleteAll: "Eliminar Todo",
          cancelSelection: "Cancelar",
          noSelection: "Selecciona al menos un contacto para eliminar",
        },
        modal: {
          profilePhoto: "Foto de Perfil",
          imageUnavailable: "Imagen no disponible",
          selectContact: "Seleccionar contacto",
          blocked: "Bloqueado",
          active: "Activo",
          notAssigned: "No asignado",
          userNotFound: "Usuario no encontrado",
        },
      },
      forwardMessage: {
        text: "Reenviado",
      },
      forwardMessageModal: {
        title: "Reenviar Mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Tokens Máximos en Respuesta",
          temperature: "Temperatura",
          apikey: "Clave API",
          max_messages: "Mensajes Máximos en Historial",
          voiceKey: "Clave de API de Voz",
          voiceRegion: "Región de Voz",
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Requerido",
          describeAI: "Describe el entrenamiento para la Inteligencia Artificial",
          informVoiceMode: "Ingresa modo de voz",
          informMaxTokens: "Ingresa número máximo de tokens",
          informTemperature: "Ingresa temperatura",
          informApiKey: "Ingresa Clave API",
          informQueue: "Ingresa cola",
          informMaxMessages: "Ingresa número máximo de mensajes",
          selectQueue: "Selecciona sector",
        },
        voices: {
          text: "Texto",
        },
        success: "¡Prompt guardado exitosamente!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Tokens Máximos en Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede deshacer!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
        toasts: {
          permissionError: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        },
      },
      contactModal: {
        title: {
          add: "Agregar Contacto",
          edit: "Editar Contacto",
        },
        form: {
          mainInfo: "Datos de Contacto",
          extraInfo: "Información Adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Deshabilitar Chatbot",
          termsLGDP: "Términos LGPD aceptados el:",
          whatsapp: "Conexión de Origen:",
        },
        buttons: {
          addExtraInfo: "Agregar Información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado exitosamente.",
        walletLinked: "¡Contacto vinculado a tu cartera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Carteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        wallet: "Cartera",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Correo Electrónico",
        actions: "Acciones",
        editWallet: "Editar Cartera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Selecciona un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Estás seguro de que deseas eliminar este contacto de la cartera?",
        deleteSuccess: "¡Contacto eliminado de la cartera exitosamente!",
        updateSuccess: "¡Cartera actualizada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "Datos de Cola",
          text: "Horarios de Negocio",
          add: "Agregar Cola",
          edit: "Editar Cola",
          confirmationDelete:
            "¿Estás seguro? Se eliminarán todas las opciones de integración.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de Cola (Bot)",
          rotate: "Rotación",
          timeRotate: "Tiempo de Rotación",
          typeRandomMode: "Tipo de Rotación",
          selectRotationType: "Selecciona tipo de rotación",
          greetingMessage: "Mensaje de Bienvenida",
          complationMessage: "Mensaje de Finalización",
          outOfHoursMessage: "Mensaje Fuera de Horario",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Lista de Archivos",
          closeTicket: "Cerrar Ticket",
          queueType: "Tipo de Menú",
          message: "Mensaje de Retorno",
          queue: "Cola de Transferencia",
          integration: "Integración",
          file: "Lista de Archivos",
          none: "Ninguno",
          selectFile: "Selecciona un Archivo",
          minutes: {
            singular: "minuto",
            plural: "minutos"
          }
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agrega opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente y el bot responderá con el mensaje y procederá",
          selectOption: "Selecciona una Opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Cola",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es requerido para proceder al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es requerido para proceder al siguiente nivel",
          selectUser: "Selecciona un Usuario",
          selectQueue: "Selecciona una Cola",
          selectIntegration: "Selecciona una Integración",
          addOptions: "Agregar Opciones",
          messageLabel: "Mensaje:",
        },
        validation: {
          tooShort: "¡Muy Corto!",
          tooLong: "¡Muy Largo!",
          required: "Requerido",
          mustHaveFriends: "Debe tener amigos",
        },
        serviceHours: {
          dayWeek: "Día de la Semana",
          startTimeA: "Hora de Inicio - Turno A",
          endTimeA: "Hora de Fin - Turno A",
          startTimeB: "Hora de Inicio - Turno B",
          endTimeB: "Hora de Fin - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar Proyecto",
          edit: "Editar Proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "Contenido JSON",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo de expiración en minutos",
          typebotKeywordFinish: "Palabra clave para finalizar el ticket",
          typebotKeywordRestart: "Palabra clave para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Retraso (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración probada exitosamente!",
          addSuccess: "Integración agregada exitosamente.",
          editSuccess: "Integración editada exitosamente.",
          errors: {
            onlyInternalAllowed: "Solo se permiten mensajes internos (notas) en este momento."
            }
        },
        integrationTypes: {
          dialogflow: "DialogFlow",
          n8n: "N8N",
          webhook: "WebHooks",
          typebot: "Typebot",
          flowbuilder: "Flowbuilder",
        },
      },
      userModal: {
        warning: "¡Para importar mensajes, debes escanear el Código QR nuevamente!",
        title: {
          add: "Agregar Usuario",
          edit: "Editar Usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Eliminar Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de Despedida",
          profile: "Perfil",
          startWork: "Hora de Inicio del Trabajo",
          endWork: "Hora de Fin del Trabajo",
          whatsapp: "Conexión Predeterminada",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Ver Tickets sin Cola",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menú Predeterminado",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver Conversaciones de Otras Colas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver Conversaciones de Otros Usuarios",
          userClosePendingTicket: "Permitir Cierre de Tickets Pendientes",
          showDashboard: "Ver Panel de Control",
          allowRealTime: "Ver Panel en Tiempo Real",
          allowConnections: "Permitir Acciones en Conexiones",
          showContacts: "Ver Contactos",
          showCampaign: "Ver Campañas",
        },
        tabs: {
          general: "General",
          permissions: "Permisos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado exitosamente.",
      },
      companyModal: {
        title: {
          add: "Agregar Empresa",
          edit: "Editar Empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Empresa guardada exitosamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Horario",
          edit: "Editar Horario",
          message: "Mensaje",
          sendError: "Error de Envío",
        },
        subtitle: "Completa el mensaje, define el destino y programa el envío.",
        sections: {
          messageInfo: "Información del Mensaje",
          messageInfoDescription: "Escribe el contenido e inserta variables disponibles rápidamente.",
          destinationStatus: "Destino y Estado",
          destinationStatusDescription: "Define conexión, apertura del ticket, agente y estado final.",
          planning: "Planificación / Recurrencia",
          planningDescription: "Configura fecha, recurrencia y comportamiento en días festivos.",
        },
        variables: {
          title: "Variables disponibles",
          helper: "Haz clic para insertar una variable",
        },
        validation: {
          messageTooShort: "Mensaje muy corto",
          required: "Requerido",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha Programada",
          sentAt: "Fecha Enviada",
          assinar: "Enviar Firma",
          assinarDescription: "Agrega automáticamente la firma al mensaje programado.",
          holidayMode: "Días",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar Horario",
        },
        success: "Horario guardado exitosamente.",
        toasts: {
          deleted: "Multimedia eliminada exitosamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar multimedia",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta multimedia?",
        },
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
          addKanban: "Nuevo Carril",
          editKanban: "Editar Carril",
          backToKanban: "VOLVER AL KANBAN",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en minutos para redirigir al carril",
          nextLaneId: "Carril",
          greetingMessageLane: "Mensaje de Bienvenida del Carril",
          rollbackLaneId: "Volver al Carril después de reanudar atención",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada exitosamente.",
        successKanban: "Carril guardado exitosamente.",
        validation: {
          messageTooShort: "Mensaje muy corto",
          required: "Requerido",
        },
      },
      fileModal: {
        title: {
          add: "Agregar Lista de Archivos",
          edit: "Editar Lista de Archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar Archivo",
        },
        form: {
          name: "Nombre de Lista de Archivos",
          message: "Detalles de la Lista",
          fileOptions: "Lista de Archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de Opción",
        },
        success: "¡Lista de archivos guardada exitosamente!",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para comenzar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ ARRASTRA Y SUELTA ARCHIVOS AQUÍ ABAJO ⬇️",
          titleFileList: "Lista de Archivos",
        },
      },
      chatInternal: {
        new: "Nuevo grupo",
        modal: {
          conversation: "Conversación",
          title: "Título",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede deshacer, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "SÍ",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todo",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
      },
      tickets: {
        search: {
          placeholder: "Buscar tickets y contactos"
        },
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todo",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abierto",
          resolverd: "Resuelto",
          all: "Todo",
          searchOnMessagesTooltip: "Marcar para buscar también en contenido de mensajes (más lento)",
          ascending: "Ascendente",
          descending: "Descendente"
        },
        status: {
          open: "Abierto",
          pending: "Pendiente",
          group: "Grupo",
          closed: "Resuelto",
        },
        toasts: {
          deleted: "La atención que estabas manejando ha sido eliminada.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abierto" },
          closed: { title: "Resuelto" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar atención y mensajes",
          filterConections: "Filtrar por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtrar por Usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todo",
          returnQueue: "Volver a la Cola",
          scredule: "Horario",
          deleteTicket: "Eliminar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar Ticket con Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket sin Mensaje de Despedida",
        },
        status: {
          pending: "Ticket Pendiente"
        }
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a Cola",
        fieldQueuePlaceholder: "Selecciona una cola",
        fieldWhatsapp: "Selecciona un WhatsApp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer: "Notas - mensaje interno, no se enviará al cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Llamada",
        today: "Hoy",
        missedCall: "Llamada de voz/video perdida en",
        pendingHeader: "Esperando",
        assignedHeader: "En Atención",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
          "No se encontraron atenciones con este estado o término de búsqueda",
        noQueue: "Sin Cola",
        metaReplyWindow:
          "Tienes 24 horas para responder después de recibir un mensaje, de acuerdo con las políticas de Meta.",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar a PDF",
          kanbanActions: "Opciones de Workflow",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Selecciona Sector",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar Contacto",
        fieldLabel: "Escribe para buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Panel de Control",
          connections: "Conexiones",
          chatsTempoReal: "Panel en Tiempo Real",
          tickets: "Atenciones",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Carteras",
          queues: "Colas y Chatbot",
          tags: "Etiquetas",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          files: "Listas de Archivos",
          helps: "Centro de Ayuda",
          messagesAPI: "API",
          schedules: "Horarios",
          campaigns: "Campañas",
          annoucements: "Anuncios",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Workflow",
          prompts: "Talk.AI",
          allConnections: "Gestionar Conexiones",
          reports: "Reportes",
          management: "Gestión",
        },
        submenuLabels: {
          flowbuilder: "Flujo de Automatización",
          flowCampaign: "Flujo de Campaña",
          flowConversation: "Flujo de Conversación",
        },
        tooltips: {
          expandMenu: "Expandir menú",
          collapseMenu: "Contraer menú",
        },
        campaigns: {
          subMenus: {
            list: "Lista",
            listContacts: "Lista de Contactos",
            settings: "Configuración",
          },
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y continuaré tu servicio.",
            virtualAssistant: "Asistente Virtual",
            token: "Token inválido, por favor contacta al administrador de la plataforma.",
          },
          message: {
            location: "Ubicación",
            contact: "Contacto",
          },
          notRegister: "No se encontraron registros",
          refresh: "Actualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Portugués",
        es: "Español",
        en: "Inglés",
        tr: "Turco",
      },
      messagesAPI: {
        title: "API",
        toSend: "PARA ENVIAR",
        send: "Enviar",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token Registrado",
          userId: "ID de Usuario/Agente",
          queueId: "ID de Cola",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del Archivo",
          media: "Archivo",
          token: "Token Registrado",
        },
        forbiddenMessage: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        successMessage: "Mensaje enviado exitosamente",
        API: {
          title: "Documentación de Envío de Mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes Multimedia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Notas Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrar, accede al menú 'Conexiones', haz clic en el botón editar en la conexión e inserta el token en el campo apropiado.",
            comments2:
              "El número de envío no debe tener máscara o caracteres especiales y debe estar compuesto por:",
            codeCountry: "Código de País",
            code: "Código de Área (DDD)",
            number: "Número de Teléfono",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se encuentra la lista de información requerida para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensajes Multimedia",
            instructions:
              "A continuación se encuentra la lista de información requerida para enviar mensajes multimedia:",
            endpoint: "Endpoint:",
            method: "Método:",
            headers: "Encabezados:",
            formData: "FormData:",
            file: "archivo",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        openChat: "Abrir chat",
        newMessage: "Nuevo mensaje",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¡Esta acción es irreversible! ¿Deseas continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado exitosamente!",
          deleted: "¡Atajo eliminado exitosamente!",
        },
        validation: {
          required: "Requerido",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Permitir Edición",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir Visualización",
          attachMedia: "Adjuntar Multimedia",
          editMedia: "Editar multimedia",
          removeMedia: "Eliminar multimedia",
          newFile: "Nuevo Archivo",
          newAudioRecorded: "Nuevo audio grabado",
          newAudio: "Nuevo Audio",
          chooseNewMediaToReplace: "Elige nueva multimedia para reemplazar:",
          chooseMediaOption: "Elige una opción para adjuntar multimedia:",
          attachFile: "Adjuntar Archivo",
          recordAudio: "Grabar Audio",
          cancelEdit: "Cancelar Edición",
          type: "Tipo",
          value: "Valor",
          status: "Estado",
          language: "Idioma",
          category: "Categoría",
          metaID: "Meta ID",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
          media: "Multimedia",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
          downloadExample: "Descargar Hoja de Cálculo de Ejemplo",
          viewContacts: "Ver Contactos",
          edit: "Editar",
          delete: "Eliminar",
          selectAll: "Seleccionar todo",
          deselectAll: "Deseleccionar todo",
        },
        modal: {
          selectContacts: "Seleccionar contactos",
        },
        emptySelection: "No se encontraron contactos.",
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Registro eliminado exitosamente.",
        },
        summary: {
          totalLists: "Total de listas",
          totalContacts: "Total de contactos",
        },
        emptyState: {
          title: "No se encontraron listas",
          description: "Crea tu primera lista de contactos.",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar",
          importFromContacts: "Importar desde contactos",
        },
        status: {
          valid: "WhatsApp válido",
          invalid: "WhatsApp no válido",
        },
        summary: {
          total: "Total",
          valid: "Válidos",
          invalid: "No válidos",
        },
        emptyState: {
          title: "No se encontraron contactos",
          description: "Agrega o importa contactos a esta lista.",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
          importMessage:
            "¿Deseas importar los contactos de esta hoja de cálculo?",
          importTitlte: "Importar",
          downloadExample: "Descargar la hoja de ejemplo.",
        },
        toasts: {
          deleted: "Registro eliminado exitosamente.",
        },
      },
      kanban: {
        title: "Workflow",
        searchPlaceholder: "Buscar",
        subMenus: {
          list: "Tablero",
          tags: "Carriles",
        },
        sortOrder: "Ordenar por",
        ticketNumber: "Número de Ticket",
        lastMessage: "Último Mensaje",
        valueDesc: "Valor (mayor a menor)",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        search: "Buscar",
        addColumns: "+ Agregar columnas",
        ticketPrefix: "Ticket #",
        assignValue: "Asignar Valor",
        value: "Valor",
        remove: "Eliminar",
        viewTicket: "Ver Ticket",
        editValue: "Editar",
        saveValue: "Guardar",
        cancel: "Cancelar",
        opportunityValue: "Valor de Oportunidad",
        total: "Total",
        ticketUpdatedSuccess: "¡Etiqueta de Ticket actualizada exitosamente!",
        ticketRemovedSuccess: "¡Etiqueta de Ticket eliminada!",
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Buscar",
        dialog: {
          form: {
            whatsapp: "Conexión",
            openTicket: "Abrir Ticket",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            statusTicket: "Estado del Ticket",
            closedTicketStatus: "Cerrado",
            openTicketStatus: "Abierto",
          },
        },
        subMenus: {
          list: "Listado",
          listContacts: "Lista de Contactos",
          settings: "Configuración",
        },
        settings: {
          randomInterval: "Intervalo Aleatorio de Envío",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo más largo después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de Envío Más Grande",
          addVar: "Agregar Variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          option: "Ninguno",
          disabled: "Deshabilitado",
          enabled: "Habilitado",
          status: "Estado",
          scheduledAt: "Programado",
          completedAt: "Completado",
          confirmation: "Confirmación",
          actions: "Acciones",
          recurrence: "Recurrencia",
          nextExecution: "Próxima Ejecución",
        },
        toasts: {
          deleted: "¡Campaña eliminada exitosamente!",
          cancel: "¡Campaña cancelada exitosamente!",
          restart: "¡Campaña reiniciada exitosamente!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        filters: {
          statusFilter: "Filtrar por Estado",
          recurrenceFilter: "Filtrar por Recurrencia",
          all: "Todo",
          allRecurrence: "Todo",
          inactive: "Inactivo",
          scheduled: "Programado",
          inProgress: "En Progreso",
          canceled: "Cancelado",
          finished: "Finalizado",
          recurring: "Recurrente",
          single: "Individual",
        },
        quickActions: {
          title: "Acciones rápidas",
        },
        legend: {
          show: "Mostrar leyenda",
          hide: "Ocultar leyenda",
        },
        summary: {
          total: "Total",
          scheduled: "Programadas",
          inProgress: "En curso",
          finished: "Finalizadas",
          canceled: "Canceladas",
          inactive: "Inactivas",
        },
        emptyState: {
          title: "No se encontraron campañas",
          description: "Ajusta los filtros o crea una nueva campaña.",
        },
        recurrence: {
          title: "Recurrencia",
          type: {
            daily: "Diario",
            weekly: "Semanal",
            biweekly: "Quincenal",
            monthly: "Mensual",
            yearly: "Anual",
          },
          nextExecution: "Próxima Ejecución",
          executions: "ejecuciones",
          single: "Individual",
          finished: "Recurrencia finalizada",
          stopTitle: "Detener Recurrencia",
          stopMessage: "¿Estás seguro de que deseas detener la recurrencia de esta campaña? La campaña actual continuará ejecutándose, pero no habrá más ejecuciones futuras.",
          stopSuccess: "¡Recurrencia detenida exitosamente!",
        },
        status: {
          inactive: "Inactivo",
          scheduled: "Programado",
          inProgress: "En Progreso",
          canceled: "Cancelado",
          finished: "Finalizado",
        },
        tooltips: {
          recurringCampaign: "Campaña Recurrente",
          stop: "Detener Campaña",
          restart: "Reiniciar Campaña",
          stopRecurrence: "Detener Recurrencia",
          report: "Reporte",
          edit: "Editar",
          delete: "Eliminar",
        },
        noSchedule: "Sin horario",
        notCompleted: "No completado",
        listRemoved: "Lista eliminada",
        whatsappRemoved: "WhatsApp eliminado",
        notDefined: "No definido",
        notDefinedFemale: "No definida",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        tag: "Etiqueta",
        permissionError: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Lectura",
          help: "Usa variables como {name}, {number}, {email}, o define variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Horario",
            confirmation: "Confirmación",
            contactList: "Lista de Contactos",
            tagList: "Etiquetas",
            statusTicket: "Estado del Ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir Ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envío",
            restart: "Reiniciar Envío",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación completada exitosamente.",
          cancel: "Campaña cancelada.",
          restart: "Campaña reiniciada.",
          deleted: "Registro eliminado exitosamente.",
        },
      },
      campaignReport: {
        title: "Reporte de Campaña",
        inactive: "Inactivo",
        scheduled: "Programado",
        process: "En Progreso",
        cancelled: "Cancelado",
        finished: "Completado",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregado",
        connection: "Conexión",
        contactLists: "Lista de Contactos",
        schedule: "Horario",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Anuncios",
        searchPlaceholder: "Buscar",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Anuncio",
          contactLists: "Listas de Anuncios",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Anuncio",
          add: "Nuevo Anuncio",
          update: "Editar Anuncio",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alto",
            medium: "Medio",
            low: "Bajo",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación completada exitosamente.",
          deleted: "Registro eliminado exitosamente.",
        },
      },
      campaignsConfig: {
        title: "Configuración de Campañas",
        intervals: "Intervalos",
        randomInterval: "Intervalo Aleatorio de Envío",
        noBreak: "Sin Intervalo",
        intervalGapAfter: "Intervalo más largo después de",
        undefined: "No definido",
        messages: "mensajes",
        laggerTriggerRange: "Intervalo de envío más grande",
        save: "Guardar",
        seconds: "segundos",
        forbiddenMessage: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        confirmDelete: "¿Estás seguro de que deseas eliminar esta variable?",
        deleteMessage: "Esta acción no se puede deshacer.",
      },
      queues: {
        title: "Colas y Chatbot",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de Bienvenida",
          orderQueue: "Orden de Cola (Bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar Cola",
        },
        toasts: {
          success: "Cola guardada exitosamente.",
          deleted: "Cola eliminada exitosamente.",
          clickSave: "Haz clic en guardar para registrar los cambios",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede deshacer! Las atenciones de esta cola seguirán existiendo pero ya no se asignarán a una cola.",
        },
      },
      queue: {
        queueData: "Datos de Cola",
      },
      queueSelect: {
        inputLabel: "Colas",
        inputLabelRO: "Colas Solo Lectura",
        withoutQueue: "Sin Cola",
      },
      reports: {
        title: "Reportes de Atención",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Último Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
          valorVenda: "Valor de Venta",
          motivoNaoVenda: "Motivo de No Venta",
          finalizadoComVenda: "Cerrado con Venta",
          wallet: "Cartera",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Calificados",
          exportExcel: "Exportar a Excel",
        },
        searchPlaceholder: "Buscar...",
        tooltips: {
          logsTicket: "Registros de Ticket",
          accessTicket: "Acceder a Ticket",
          exportExcel: "Exportar a Excel",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha de inicio",
          endDate: "Fecha de fin",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Cola",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha de Apertura",
            openTime: "Hora de Apertura",
            closeDate: "Fecha de Cierre",
            closeTime: "Hora de Cierre",
            supportTime: "Tiempo de Soporte",
            nps: "NPS",
            valorVenda: "Valor de Venta",
            motivoNaoVenda: "Motivo de No Venta",
            finalizadoComVenda: "Cerrado con Venta",
          },
        },
        finalizadoComVenda: {
          sim: "Sí",
          nao: "No",
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última Actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? Esta acción no se puede deshacer y será eliminada de colas y conexiones vinculadas.",
        },
        toasts: {
          deleted: "¡Integración eliminada exitosamente!",
          permissionError: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        },
        validation: {
          tooShort: "¡Muy Corto!",
          tooLong: "¡Muy Largo!",
          required: "Requerido",
        },
        languages: {
          portuguese: "Portugués",
          english: "Inglés",
          spanish: "Español",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Hora de Inicio del Trabajo",
          endWork: "Hora de Fin del Trabajo",
          actions: "Acciones",
          ID: "ID",
          avatar: "Avatar",
        },
        buttons: {
          add: "Agregar Usuario",
          generateExistingChats: "Generar Chats Existentes",
        },
        summary: {
          total: "Total de usuarios",
        },
        emptyState: {
          title: "No se encontraron usuarios",
          description: "Agrega el primer usuario para comenzar.",
        },
        toasts: {
          deleted: "Usuario eliminado exitosamente.",
          chatCreated: "¡Chat creado exitosamente!",
          chatsGenerated: "¡Chats generados exitosamente!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Se perderán todos los datos del usuario. Los tickets abiertos para este usuario se moverán a la cola.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Colas",
          useCampaigns: "Campañas",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programación",
          createdAt: "Creado En",
          dueDate: "Fecha de Vencimiento",
          lastLogin: "Último Inicio de Sesión",
          folderSize: "Tamaño de la Carpeta",
          totalFiles: "Total de Archivos",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "$",
          yes: "Sí",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimensual",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          generateInvoice: "Generar Factura",
          currency: "Moneda",
          noCompanies: "No se encontraron empresas."
        },
        buttons: {
          add: "Agregar Empresa",
        },
        toasts: {
          deleted: "Empresa eliminada exitosamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Se perderán todos los datos de la empresa. Los tickets abiertos para usuarios en esta empresa se moverán a la cola.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          currency: "Moneda",
          campaigns: "Campañas",
          schedules: "Horarios",
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
          public: "Público",
          trial: "Prueba",
          trialDays: "Días de Prueba",
        },
      },
      helps: {
        title: "Centro de Ayuda",
        settings: {
          codeVideo: "Código de Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Horarios",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Semana Laboral",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este rango.",
        errors: {
          noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Te estamos redirigiendo.",
        },
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar este Horario?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha Programada",
          sentAt: "Fecha Enviada",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Horario",
        },
        toasts: {
          deleted: "Horario eliminado exitosamente.",
        },
      },
      tags: {
        title: "Etiquetas",
        addColumns: "+ AGREGAR COLUMNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Workflow",
          color: "Color",
          tickets: "Registros de Etiqueta",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Etiqueta",
        },
        summary: {
          total: "Total",
          contacts: "Contactos",
        },
        emptyState: {
          title: "No se encontraron etiquetas",
          description: "Crea tu primera etiqueta.",
        },
        toasts: {
          deleted: "Etiqueta eliminada exitosamente.",
        },
        contactModal: {
          title: "Contactos",
          tableHeaders: {
            id: "ID",
            name: "Nombre",
            number: "Número",
            actions: "Acciones",
          },
        },
      },
      tagsKanban: {
        title: "Carriles",
        laneDefault: "Abierto",
        backToKanban: "VOLVER AL KANBAN",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar este Carril?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Carril",
        },
        toasts: {
          deleted: "Carril eliminado exitosamente.",
        },
      },
      files: {
        title: "Listas de Archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "¡Lista de archivos eliminada exitosamente!",
          deletedAll: "¡Todas las listas de archivos fueron eliminadas exitosamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todo",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todo",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?",
        },
      },
      settings: {
        success: "Configuración guardada exitosamente.",
        title: "Configuración",
        finalization: {
          title: "Finalización de Atención",
          generalConfig: "Configuración General",
          askSaleValue: "Informar el valor de la venta al finalizar la atención",
          askSaleValueHelper: "Cuando está habilitado, el campo de valor de la venta aparecerá en el modal de finalización",
          reasonsTitle: "Motivos de Finalización",
          addReason: "Agregar Motivo",
          editReason: "Editar Motivo",
          reasonName: "Nombre del Motivo",
          reasonDescription: "Descripción (opcional)",
          cancel: "Cancelar",
          saving: "Guardando...",
          update: "Actualizar",
          add: "Agregar",
          empty: "No hay motivos registrados. Haz clic en \"Agregar Motivo\" para comenzar.",
          table: {
            name: "Nombre",
            description: "Descripción",
            actions: "Acciones",
            noDescription: "Sin descripción"
          },
          toasts: {
            updateSuccess: "Configuración actualizada con éxito!",
            updateError: "Error al actualizar la configuración",
            deleteError: "Error al eliminar el motivo"
          }
        },
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de Usuario",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Oficina",
            queueManagement: "Gestión de Colas",
            companyManagement: "Gestión de Empresa",
            connectionManagement: "Gestión de Conexiones",
            sendGreetingAccepted: "Enviar Saludo al Aceptar Ticket",
            sendMsgTransfTicket:
              "Enviar Mensaje de Transferencia entre Departamentos/Agentes",
            checkMsgIsGroup: "Ignorar Mensajes de Grupo",
            chatBotType: "Tipo de Bot",
            userRandom: "Selección Aleatoria de Agente",
            buttons: "Botones",
            acceptCallWhatsapp: "¿Notificar que la llamada de WhatsApp no es aceptada?",
            sendSignMessage: "Permitir que el agente elija enviar Firma",
            sendGreetingMessageOneQueues:
              "Enviar Saludo cuando existe solo una cola",
            sendQueuePosition: "Enviar Mensaje de Posición en Cola",
            sendFarewellWaitingTicket: "Enviar Mensaje de Despedida mientras Espera",
            acceptAudioMessageContact:
              "¿Aceptar Mensajes de Audio de Todos los Contactos?",
            enableLGPD: "Habilitar Procesamiento LGPD",
            requiredTag: "Etiqueta Requerida para Cerrar Ticket",
            closeTicketOnTransfer:
              "Cerrar Ticket al Transferir a Otra Cola",
            DirectTicketsToWallets: "Mover Automáticamente Cliente a Cartera",
            showNotificationPending: "Mostrar Notificación para Tickets Pendientes",
            copyContactPrefix: "Prefijo de Copia de Contacto",
            copyContactPrefixPlaceholder: "Ej: COPY_",
            schedules: "Horarios",
            configurationPix: "Configuración Pix Efí (GerenciaNet)",
            mercadoPago: "Mercado Pago",
            stripe: "Stripe",
            asaas: "ASAAS",
            clientId: "ID de Cliente",
            clientSecret: "Secreto de Cliente",
            pixKey: "Clave PIX",
            accessToken: "Token de Acceso",
            stripePrivateKey: "Clave Privada de Stripe",
            asaasToken: "Token Asaas",
            configurationCopyPrefix: "Configuración de Prefijo de Copia de Contacto",
            successOperation: "Operación actualizada exitosamente.",
            text: "Texto",
            finalizationAttendance: "Finalización de Servicio"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de Posición en Cola",
            AcceptCallWhatsappMessage: "Mensaje para Informar Llamada No Aceptada",
            greetingAcceptedMessage: "Mensaje de Saludo al Aceptar Ticket",
            transferMessage:
              "Mensaje de Transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de Bienvenida (LGPD)",
            linkLGPD: "Enlace de Política de Privacidad",
            obfuscateMessageDelete: "Ofuscar Mensaje Eliminado",
            alwaysConsent: "Siempre Solicitar Consentimiento",
            obfuscatePhoneUser: "Ofuscar Número de Teléfono del Usuario",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Deseas dejar una calificación de servicio para el cliente?",
          dialogClosingTitle: "¡Cerrando el servicio con el cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Calificación",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elige un menú de calificación",
          notMessage: "Ningún mensaje seleccionado",
          amount: "Valor de Prospección",
          buttons: {
            return: "Volver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Calificación",
            enableIntegration: "Habilitar Integración",
            disableIntegration: "Deshabilitar Integración",
            logTicket: "Registros de Ticket",
            requiredTag: "Debes asignar una etiqueta antes de cerrar el ticket.",
            greetingAcceptedMessage:
              "Debes configurar un mensaje de saludo al aceptar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Escribe un mensaje o presiona / para respuestas rápidas",
        placeholderOpen: "Escribe un mensaje o presiona / para respuestas rápidas",
        placeholderPending:
          "Mensaje interno (ticket pendiente de aceptación)...",
        placeholderClosed: "Reabre o acepta este ticket para enviar un mensaje.",
        signMessage: "Firma",
        privateMessage: "Mensaje Privado",
        internalMessageLabel: "Mensaje Interno",
      },
      contactDrawer: {
        header: "Detalles de Contacto",
        buttons: {
          edit: "Editar Contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Información Adicional",
      },
      messageVariablesPicker: {
        label: "Variables Disponibles",
        vars: {
          contactFirstName: "Nombre",
          contactName: "Nombre Completo",
          user: "Agente",
          greeting: "Saludo",
          protocolNumber: "Número de Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Número de Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Horario",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Notas de Contacto",
        resolveWithNoFarewell: "Resolver sin Despedida",
        acceptAudioMessage: "¿Aceptar mensajes de audio del contacto?",
        appointmentsModal: {
          title: "Notas de Ticket",
          textarea: "Nota",
          placeholder: "Ingresa la información que deseas registrar aquí",
        },
        confirmationModal: {
          title: "Eliminar el ticket del contacto",
          titleFrom: "del contacto",
          message:
            "¡Atención! Se perderán todos los mensajes relacionados con este ticket.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Deshabilitar Firma",
          privateMessage: "Habilitar/Deshabilitar Mensaje Privado",
          meet: "Enviar enlace de videoconferencia",
        },
        type: {
          imageVideo: "Fotos y Videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Llamada de Video",
          template: "Plantilla Meta",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Hablar Con",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede deshacer.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Colas",
          value: "Valor",
          expirationDate: "Fecha de Vencimiento",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_USER_EMAIL_EXISTS: "Ya existe un usuario con este correo electrónico.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifica la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no está inicializada. Verifica la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifica la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudo descargar multimedia de WhatsApp. Verifica la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor intenta de nuevo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar mensaje de WhatsApp. Verifica la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "Ya existe un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor inicia sesión.",
        ERR_USER_CREATION_DISABLED:
          "El administrador deshabilitó la creación de usuarios.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhatsApp, probablemente sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elige otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es requerido si hay más de una cola.",
        ERR_OUT_OF_HOURS: "¡Fuera del Horario de Negocio!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Encabezados:",
        headerAuthorization:
          "Autorización Bearer (token registrado) y Content-Type (application/json)",
        body: "Cuerpo:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de Usuario o ""',
        fieldQueueId: '"queueId": ID de Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "El Envío de Prueba",
      },
      recurrenceSection: {
        title: "Recurrencia",
        description:
          "Puedes elegir enviar el mensaje recurrentemente y seleccionar el intervalo. Si es un mensaje único, no cambies nada en esta sección.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor",
        sendAsManyTimes: "Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Enviar también en días festivos",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
        servicePanel: {
          allowRealTime: "Panel de Servicio",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de Servicio",
      },
      financial: {
        title: "Facturas",
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
        pay: "PAGAR",
        paid: "PAGADO",
        expired: "Vencido",
        open: "Abierto",
        attentionMessage: "Atención:",
        expiredWarning: "Tu suscripción ha vencido. Por favor contacta soporte para regularizar tu situación.",
        summary: {
          total: "Total",
          open: "Abiertas",
          paid: "Pagadas",
          expired: "Vencidas",
        },
        emptyState: {
          title: "No se encontraron facturas",
          description: "No hay facturas para mostrar.",
        },
        yes: "Sí",
        no: "No",
      },
      statusFilter: {
        statusFilter: "Filtrar por Estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
        accessTicket: "Acceder a Ticket",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campañas",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del activador de frase",
        chooseAStream: "Elige un flujo",
        whichPhraseTriggersTheFlow: "¿Qué frase activa el flujo?",
        selectAConnection: "Selecciona una Conexión",
        status: "Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA",
        saveCampaign: "Guardar Campaña",
        title: "Campañas de Flujo",
        newCampaign: "Nueva Campaña",
        editCampaign: "Editar campaña",
        deleteCampaign: "Eliminar campaña",
        deleteSuccess: "Campaña eliminada exitosamente",
        noConnection: "Sin conexión",
        connections: "Conexiones",
        active: "Activo",
        disabled: "Deshabilitado",
        nameNotDefined: "Nombre no definido",
        phrasesConfigured: "frase(s) configurada(s)",
        noCampaignsFound: "No se encontraron campañas",
        clickToCreateFirst: "Haz clic en 'Nueva Campaña' para crear tu primera campaña de flujo",
        moreConnections: "Más",
        connection: "conexión(es)",
        actions: "Acciones",
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "Usuario no encontrado",
        noUserAvailable: "Usuario no disponible",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
        audio: "[Audio]",
        image: "[Imagen]",
        video: "[Video]",
        file: "[Archivo]",
        group: "Grupo",
        user: "Usuario",
        errorLoadingUsers: "Error al cargar usuarios",
        chatAlreadyExists: "¡El chat con este usuario ya existe!",
        chatCreatedSuccess: "¡Chat creado exitosamente!",
        errorCreatingChat: "Error al crear chat",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm: "¿Estás seguro de que deseas eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Selecciona chat",
        doubleClickToReply: "Haz doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haz clic para ir al mensaje original",
        errorCreatingEditingChat: "Error al crear/editar chat",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        deleteMessage: "¿Estás seguro de que deseas eliminar este mensaje?",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Selecciona chat",
        forward: "Reenviar",
        noChats: "Sin chat disponible",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "Sin chat encontrado",
        noGroups: "Sin grupo encontrado",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar datos",
        addGroupPhoto: "Agregar Foto del Grupo",
        changeGroupPhoto: "Cambiar Foto del Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Estás seguro de que deseas eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          subtitle: "Crea un grupo interno y agrega rápidamente a los participantes",
          save: "Guardar",
          cancel: "Cancelar",
          name: "Nombre del grupo",
          description: "Descripción",
          filterUsers: "Buscar usuarios para agregar",
          create: "Crear",
          edit: "Editar",
        },
      },
      flowBuilder: {
        title: "Flujos de Conversación",
        titleWithCount: "Flujos de Conversación ({count})",
        searchPlaceholder: "Buscar flujos...",
        newFlow: "Nuevo Flujo",
        createFirstFlow: "Crear Primer Flujo",
        noFlowsFound: "No se encontraron flujos",
        noFlowsCreated: "Ningún flujo creado aún",
        tryOtherSearchTerms: "Intenta usar otros términos de búsqueda",
        createFirstFlowDescription: "Crea tu primer flujo de conversación para automatizar el servicio al cliente",
        flowStatus: {
          active: "Activo",
          inactive: "Inactivo"
        },
        flowActions: {
          edit: "Editar",
          duplicate: "Duplicar",
          delete: "Eliminar",
          editFlow: "Editar flujo",
          deleteFlow: "Eliminar flujo"
        },
        confirmations: {
          deleteTitle: "Eliminar flujo",
          deleteMessage: "Esta acción no se puede deshacer. Se perderán todas las integraciones relacionadas.",
          duplicateTitle: "Duplicar flujo",
          duplicateMessage: "Se creará una copia del flujo para que la edites."
        },
        toasts: {
          flowDeleted: "Flujo eliminado exitosamente",
          flowDuplicated: "Flujo duplicado exitosamente",
          flowCreated: "Flujo creado exitosamente",
          flowUpdated: "Flujo actualizado exitosamente",
          errorDeleting: "Error al eliminar flujo",
          errorDuplicating: "Error al duplicar flujo"
        },
        modal: {
          title: "Flujo de Conversación",
          newFlow: "Nuevo Flujo",
          editFlow: "Editar Flujo",
          flowName: "Nombre del Flujo",
          flowNamePlaceholder: "Ingresa nombre del flujo",
          save: "Guardar",
          cancel: "Cancelar"
        }
      },
      flowBuilderConfig: {
        title: "Editor de Flujo",
        addNodes: "Agregar Nodos",
        startNode: {
          title: "Inicio del flujo",
          description: "¡Este bloque marca el inicio de tu flujo!"
        },
        categories: {
          basics: "Básicos",
          content: "Contenido",
          interaction: "Interacción",
          logic: "Lógica",
          system: "Sistema",
          integrations: "Integraciones"
        },
        nodes: {
          start: {
            name: "Inicio",
            description: "Punto de inicio del flujo"
          },
          content: {
            name: "Contenido",
            description: "Envía texto, imagen, audio o video"
          },
          text: {
            name: "Texto",
            description: "Mensaje de texto simple"
          },
          menu: {
            name: "Menú",
            description: "Menú de opciones para usuario"
          },
          input: {
            name: "Entrada",
            description: "Recopilar entrada del usuario"
          },
          interval: {
            name: "Intervalo",
            description: "Pausa de ejecución por tiempo"
          },
          randomizer: {
            name: "Aleatorizador",
            description: "Selección de ruta aleatoria"
          },
          queues: {
            name: "Colas",
            description: "Gestionar colas de servicio"
          },
          tags: {
            name: "Etiquetas",
            description: "Agregar etiquetas a contacto"
          },
          removeTag: {
            name: "Eliminar Etiqueta",
            description: "Eliminar etiquetas del contacto"
          },
          switchFlow: {
            name: "Cambiar Flujo",
            description: "Cambiar a otro flujo"
          },
          attendant: {
            name: "Agente",
            description: "Transferir a agente"
          },
          closeTicket: {
            name: "Cerrar Ticket",
            description: "Finalizar servicio"
          },
          webhook: {
            name: "WebHook",
            description: "Integración HTTP"
          },
          webform: {
            name: "Formulario Web",
            description: "Crear formulario web"
          },
          variable: {
            name: "Variable",
            description: "Establecer variables globales"
          },
          assign: {
            name: "Asignar",
            description: "Asignar chat a agente"
          },
          openAI: {
            name: "OpenAI",
            description: "Integración de OpenAI"
          },
          gemini: {
            name: "Gemini",
            description: "Integración de Google Gemini"
          }
        },
        saveButton: "Guardar Flujo",
        zoomIn: "Aumentar Zoom",
        zoomOut: "Reducir Zoom",
        flowSaved: "¡Flujo guardado exitosamente!",
        errorSaving: "Error al guardar flujo",
        seconds: "seg",
        modals: {
          menu: {
            addTitle: "Agregar menú al flujo",
            editTitle: "Editar menú",
            addButton: "Agregar",
            saveButton: "Guardar",
            cancelButton: "Cancelar"
          },
          text: {
            addTitle: "Agregar texto al flujo",
            editTitle: "Editar texto",
            addButton: "Agregar",
            saveButton: "Guardar",
            cancelButton: "Cancelar"
          },
          interval: {
            addTitle: "Agregar intervalo al flujo",
            editTitle: "Editar intervalo",
            addButton: "Agregar",
            saveButton: "Guardar",
            cancelButton: "Cancelar"
          },
          image: {
            addTitle: "Agregar imagen al flujo",
            editTitle: "Editar imagen",
            addButton: "Agregar",
            saveButton: "Guardar",
            cancelButton: "Cancelar"
          },
          audio: {
            addTitle: "Agregar audio al flujo",
            editTitle: "Editar audio",
            addButton: "Agregar",
            saveButton: "Guardar",
            cancelButton: "Cancelar"
          },
          video: {
            addTitle: "Agregar video al flujo",
            editTitle: "Editar video",
            addButton: "Agregar",
            saveButton: "Guardar",
            cancelButton: "Cancelar"
          }
        }
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Cargar",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",
        sections: {
          general: "Configuración General",
          generalDescription: "Configura el nombre de la aplicación e información básica",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza colores primarios para temas claros y oscuros",
          logos: "Logos e Imágenes",
          logosDescription: "Carga logos y imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Reporte de Soporte",
        ticketId: "ID del Ticket",
        client: "Cliente",
        number: "Número",
        agent: "Agente",
        date: "Fecha",
        lastMessage: "Último Mensaje",
        fullReport: "El reporte completo está adjunto arriba",
        resolveAndTriggerIntegration: "Resolver e Activar Integración",
        elementNotFoundForExport: "Elemento no encontrado para exportar.",
        reportFilename: "reporte_soporte",
      },
    },
    salesReport: {
      title: "Reporte de Ventas",
      filters: {
        startDate: "Fecha de Inicio",
        endDate: "Fecha de Fin",
        user: "Usuario",
        allUsers: "Todos los usuarios",
        search: "Buscar"
      },
      table: {
        attendant: "Agente",
        date: "Fecha",
        saleValue: "Valor de Venta",
        noSaleReason: "Motivo de No Venta",
        finalizationReason: "Motivo de Finalización",
        totalSales: "Total de Ventas",
        totalSalesValue: "Valor Total de Ventas",
        totalTickets: "Total de Tickets",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas"
      }
    },
    placeholders: {
      chooseFlow: "Elige un flujo",
      filterByTags: "Filtrar por Etiquetas",
      departments: "Departamentos",
      searchTemplates: "Buscar Plantillas",
      emailAddress: "Dirección de correo electrónico",
      contacts: "Contactos",
      tags: "Etiquetas",
      users: "Usuarios",
      azureSpeechKey: "Clave del Servicio de Habla de Azure",
      search: "Buscar",
      selectOption: "Selecciona una opción",
      typeHere: "Escribe aquí",
      enterValue: "Ingresa valor",
      selectDate: "Selecciona fecha",
      chooseFile: "Elige archivo"
    },
    validation: {
      required: "Requerido",
      invalidEmail: "Correo electrónico inválido",
      tooShort: "Muy corto",
      tooLong: "Muy largo",
      minLength: "Mínimo {{min}} caracteres",
      maxLength: "Máximo {{max}} caracteres",
      requiredField: "Campo requerido",
      apiKeyRequired: "Se requiere Clave API",
      voiceModeRequired: "Se requiere modo de voz",
      voiceKeyRequired: "Se requiere Clave de Voz para síntesis de voz",
      voiceRegionRequired: "Se requiere Región de Voz para síntesis de voz",
      keywordEmpty: "La palabra clave no puede estar vacía",
      goalRequired: "Se requiere Meta cuando auto-completar está activo",
      ratingRequired: "Se requiere Calificación"
    },
    toasts: {
      common: {
        error: "Error al procesar solicitud",
        success: "Operación completada exitosamente",
        loading: "Cargando...",
        warning: "Advertencia",
        info: "Información"
      },
      finalizacaoVenda: {
        informValue: "Por favor ingresa el monto de venta",
        ticketFinalized: "¡Ticket finalizado exitosamente!",
        errorFinishing: "Error al finalizar ticket"
      },
      flowBuilder: {
        tagRemoved: "¡Etiqueta eliminada exitosamente!",
        selectTag: "Selecciona una etiqueta para eliminar",
        nodeAdded: "Nodo agregado al flujo",
        nodeRemoved: "Nodo eliminado del flujo",
        flowSaved: "Flujo guardado exitosamente",
        errorSaving: "Error al guardar flujo"
      },
      tickets: {
        finalized: "¡Ticket finalizado exitosamente!",
        errorFinalizing: "Error al finalizar ticket",
        transferred: "Ticket transferido exitosamente",
        errorTransferring: "Error al transferir ticket",
        accepted: "Ticket aceptado exitosamente",
        errorAccepting: "Error al aceptar ticket"
      },
      settings: {
        noPermission: "¡Sin permiso para acceder!",
        saved: "Configuración guardada exitosamente",
        errorSaving: "Error al guardar configuración",
        fileRequired: "¡Por favor elige un archivo!",
        destinationRequired: "¡Por favor elige un destino!",
        fileSent: "¡Archivo enviado exitosamente!",
        errorSending: "Error al enviar archivo",
        invalidFormat: "¡Solo se permiten archivos en formato p12!"
      },
      connections: {
        created: "Conexión creada exitosamente",
        updated: "Conexión actualizada exitosamente",
        deleted: "Conexión eliminada exitosamente",
        errorCreating: "Error al crear conexión",
        errorUpdating: "Error al actualizar conexión",
        errorDeleting: "Error al eliminar conexión"
      },
      campaigns: {
        created: "Campaña creada exitosamente",
        updated: "Campaña actualizada exitosamente",
        deleted: "Campaña eliminada exitosamente",
        started: "Campaña iniciada exitosamente",
        paused: "Campaña pausada exitosamente",
        errorCreating: "Error al crear campaña",
        errorUpdating: "Error al actualizar campaña",
        errorDeleting: "Error al eliminar campaña"
      },
      contacts: {
        imported: "Contactos importados exitosamente",
        exported: "Contactos exportados exitosamente",
        deleted: "Contacto eliminado exitosamente",
        errorImporting: "Error al importar contactos",
        errorExporting: "Error al exportar contactos",
        errorDeleting: "Error al eliminar contacto"
      },
      dashboard: {
        createdTickets: "Tickets Creados"
      }
    },
    dialogs: {
      announcements: "Anuncios",
      chooseColor: "Elige un color",
      finalizationValue: "Finalización de Servicio - Valor de Venta",
      editNote: "Editar Nota",
      editMessage: "Editar Mensaje",
      forwardMessage: "Reenviar Mensaje",
      chooseOption: "Elige una opción",
      editBodyRequest: "Editar cuerpo de solicitud",
      fullApiResponse: "Respuesta API completa",
      loadingSettings: "Cargando configuración...",
      templateDetails: "Detalles de la Plantilla Seleccionada",
      selectedTemplate: {
        name: "Nombre",
        content: "Contenido",
        language: "Idioma",
        category: "Categoría"
      }
    },
    forms: {
      labels: {
        openaiModel: "Modelo de OpenAI",
        geminiModel: "Modelo de Gemini",
        responseType: "Tipo de Respuesta",
        operationMode: "Modo de Operación",
        selectChat: "Selecciona chat",
        selectCurrency: "Selecciona Moneda",
        attendant: "Agente",
        noSaleReason: "Motivo de No Venta",
        finalizationReason: "Motivo de Finalización",
        chooseAttendant: "Elige un agente",
        whatsappConnections: "Conexiones de WhatsApp",
        type: "Tipo",
        campaigns: "Campañas",
        sendAsRecordedAudio: "Enviar como audio grabado",
        noSales: "Sin Ventas",
        welcomeFlow: "Flujo de bienvenida",
        defaultResponseFlow: "Flujo de respuesta predeterminada"
      }
    },
    flowDefaults: {
      welcomeFlowDescription: "Este flujo se dispara solo para contactos nuevos, personas que no tienes en tu lista de contactos y que enviaron un mensaje.",
      defaultResponseFlowDescription: "La respuesta predeterminada se envía con cualquier carácter distinto de una palabra clave. ¡ATENCIÓN! Se activará si la atención ya está cerrada."
    }
  },
};

export { messages };
